var exports = {
  "Nr": "x234b8571--e7c277--card",
  "Kd": "x234b8571--e7c277--card__image",
  "fT": "x234b8571--e7c277--card__title",
  "FH": "x234b8571--e7c277--card__items",
  "gE": "x234b8571--e7c277--card__item",
};

module.exports = exports;
